import React from "react"
import { Modal } from "antd"
import ButtonRecaptchaBase from "components/ButtonRecaptcha"

interface RecaptchaModalProps {
  isModalOpen: boolean
  setIsModalOpen: (isOpen: boolean) => void
  setRecaptchaToken: (token: string | null) => void
}

export default function RecaptchaModal({ isModalOpen, setIsModalOpen, setRecaptchaToken }: RecaptchaModalProps) {
  const handleRecaptchaChange = (token: string | null) => {
    setRecaptchaToken(token)
    setIsModalOpen(false)
  }

  return (
    <Modal
      title="Recaptcha Expirou, por favor faça novamente!"
      open={isModalOpen}
      cancelButtonProps={{ hidden: true }}
      okButtonProps={{ hidden: true }}
      width={"355px"}
    >
      <div style={{ textAlign: "center", padding: "20px 0" }}>
        <ButtonRecaptchaBase onVerify={handleRecaptchaChange} style={{ width: "100px" }} />
      </div>
    </Modal>
  )
}